// ─── INCIDENCIAS MASIVAS ─────────────────────────────────────────────────────
// ─── CHATWOOT (bitácora de conversaciones de atención) ──────────────────────
export const API_URLS_CHATWOOT = {
  baseUrl: process.env.VUE_APP_API_BASE_URL,

  // Listado paginado (acepta filtros por query: canal, estado, match_estado,
  // id_cliente, con_cliente, search, fecha_desde, fecha_hasta, per_page, page)
  conversaciones: '/api/chatwoot/conversaciones',
  // Detalle de una conversación con mensajes + agentes + cliente
  conversacion: (id) => `/api/chatwoot/conversaciones/${id}`,
  // Sugerencias de cliente (por teléfono: cliente, sofonos, conversaciones previas)
  sugerenciasCliente: (id) => `/api/chatwoot/conversaciones/${id}/sugerencias-cliente`,
  // Búsqueda libre de clientes para el selector de asociación
  buscarClientes: '/api/chatwoot/clientes/buscar',
  // Asociar / desasociar (POST / DELETE) un cliente a la conversación
  asociarCliente: (id) => `/api/chatwoot/conversaciones/${id}/cliente`,
  // Búsqueda libre de usuarios del portal (para asignar a un agente)
  buscarUsuarios: '/api/chatwoot/usuarios/buscar',
  // Asignar / quitar (POST / DELETE) usuario del portal a un agente de la conversación
  usuarioAgente: (id, agenteId) => `/api/chatwoot/conversaciones/${id}/agentes/${agenteId}/usuario`,
  // Enviar un mensaje o nota interna (privado=true) hacia la conversación en Chatwoot
  enviarMensaje: (id) => `/api/chatwoot/conversaciones/${id}/mensaje`,
  // Mantenedor: configuración del módulo (switch del menú, horario y mensajes fuera de horario)
  config: '/api/chatwoot/config',
  // Próximos feriados de Chile (para el modal "Ver feriados")
  feriados: '/api/chatwoot/config/feriados',
}

export const API_INCIDENCIAS = {
  baseUrl: process.env.VUE_APP_API_BASE_URL,

  // Dashboard
  kpis:            '/api/incidencias-masivas/dashboard/kpis',
  arbolServicios:  '/api/incidencias-masivas/servicios/arbol',
  buscarServidores:  '/api/incidencias-masivas/servicios/servidores',
  buscarCategorias:  '/api/incidencias-masivas/servicios/categorias',
  estimarAlcance:    '/api/incidencias-masivas/servicios/estimar-alcance',
  plantillas:      '/api/incidencias-masivas/plantillas',
  responsables:    '/api/incidencias-masivas/usuarios/responsables',
  buscarTickets:   '/api/incidencias-masivas/tickets/buscar',

  // CRUD
  lista:    '/api/incidencias-masivas',
  detalle:  '/api/incidencias-masivas/',   // + id  →  /api/incidencias-masivas/123
}

export const API_OT = {
  baseUrl: process.env.VUE_APP_API_BASE_URL,

  lista: '/api/ordenes-trabajo',
  detail: (id) => `/api/ordenes-trabajo/${id}`,
  cambiarEstado: (id) => `/api/ordenes-trabajo/${id}/estado`,
  archivar: (id) => `/api/ordenes-trabajo/${id}/archivar`,
  desarchivar: (id) => `/api/ordenes-trabajo/${id}/desarchivar`,
  suscripcion: (id) => `/api/ordenes-trabajo/${id}/suscripcion`,
  kanbanOrden: '/api/ordenes-trabajo/kanban/orden',

  checklists: (otId) => `/api/ordenes-trabajo/${otId}/checklists`,
  checklist: (id) => `/api/ordenes-trabajo/checklists/${id}`,
  tareas: (otId) => `/api/ordenes-trabajo/${otId}/tareas`,
  tarea: (id) => `/api/ordenes-trabajo/tareas/${id}`,

  mensajes: '/api/ordenes-trabajo/mensajes',
  validateFiles: '/api/ordenes-trabajo/mensajes/validateFiles',
  mensaje: (id) => `/api/ordenes-trabajo/mensajes/${id}`,

  archivoDownload: (id) => `/api/ordenes-trabajo/archivos/${id}/download`,
  archivoRenombrar: (id) => `/api/ordenes-trabajo/archivos/${id}/renombrar`,
  responsables: '/api/ordenes-trabajo/usuarios/responsables',
  areas: '/api/ordenes-trabajo/areas',
  serviciosBuscar: '/api/ordenes-trabajo/servicios/buscar',

  checklistPlantillas: '/api/ordenes-trabajo/checklist-plantillas',
  checklistPlantilla: (id) => `/api/ordenes-trabajo/checklist-plantillas/${id}`,
  checklistGuardarPlantilla: (otId) => `/api/ordenes-trabajo/${otId}/checklist/plantilla`,
  checklistAplicarPlantilla: (otId) => `/api/ordenes-trabajo/${otId}/checklist/aplicar-plantilla`,
}

// API URLS BOARD APP
export const API_URLS_BOARD = {
  baseUrl: process.env.VUE_APP_API_BASE_URL,

  //GET ALL DATA
  getAllDataBoard: '/api/KanbanSoporte/getAllData', // LINK ../src/apps/board/store/actions.js:135
  bugReportMessageUrl: '/api/feedback/create',

  //USERS
  getUsers: '/api/usuarios/get',
  updateUser: '/api/usuarios/updatePerfil',
  getPerfil: '/api/usuarios/perfil',               // GET: datos del usuario + acceso a módulos
  updatePassword: '/api/usuarios/update-password', // POST: cambio de contraseña con 2FA

  //CLIENTS
  getClients: '/api/clientes/get',
  getClients_: '/api/clientes/getClientsSelect',
  getClientsSearch: '/api/clientes/search',
  getClientSearchToTicket: '/api/clientes/getClientSearchToTicket',
  /** POST: body { page, perPage, search, rut_cliente, ... } — buscador global de clientes (resumen) */
  clienteResumen: '/api/clienteresumen',
  /** GET ?id={clientId} — aggregated status counters for Resumen Cliente view */
  resumenClienteCounters: '/api/resumenCliente/counters',


  //CARDS
  getCardUrl: '/api/tickets/', // params: id get
  // Suscripción a un ticket (on/off). POST body { suscrito: bool } -> { suscrito }
  toggleSubscription: (id) => `/api/tickets/${id}/suscripcion`,

  // MESSAGES
  sendMessageUrl: '/api/ticketsMensajes/create', // params:
  deleteMessageUrl: '/api/ticketsMensajes/delete/', // params:
  // addCardUrl: '/api/auth/user', // params: card
  // deleteCardUrl: '/api/auth/user', // params: card
  updateCardUrl: '/api/tickets/', // params: card / post
  updateCardsUrl: '/api/KanbanSoporte/ticketChangeColumn', // params: card

  //COLUMNS
  addColumnUrl: '/api/stateTickets/create', // params: columns // LINK ../src/apps/board/store/actions.js:135
  deleteColumnUrl: '/api/stateTickets/delete/', // params: column.id // LINK ../src/apps/board/store/actions.js:150
  updateColumnUrl: '/api/stateTickets/update/', // params: nombre, oldName // LINK ../src/apps/board/store/actions.js:161
  updateColumnsUrl: '/api/KanbanSoporte/columnChangeOfPosition', // params: states // LINK ../src/apps/board/store/actions.js:176

  //  TICKETS TABLE
  getAllticketsTable: '/api/ticketsTable/getAllTickets', //
  updateTicketsTable: '/api/ticketsTable/updateTicket', //
  updateTicketsTableStatus: '/api/ticketsTable/updateTicketStatus', //
  reserveTicket: '/api/tickets/reserveTicket', //,
  mergeTicket: '/api/ticket/mergeTickets', //,
  getTicketsUser: '/api/ticket/getTicketsUser', //,

  //  REPORTES DE TICKETS (modal "Reportes")
  reporteTicketSimple: '/api/tickets/reportes/simple',     // GET ?desde&hasta&cliente_id&formato=csv|xlsx
  reporteTicketAvanzado: '/api/tickets/reportes/avanzado', // GET ?desde&hasta&cliente_id (TXT)



  validateFiles: '/api/ticketsMensajes/validateFiles',
  createTicket: '/api/ticketsTable/createTicket',
  asistenciaIa: '/api/tickets-asistencia-ia',

  checkStatus: '/api/ticketsTable/checkTickets',
  checkDashboard: '/api/ticketsTable/checkDashboard',
  getComercialUsers: '/api/tickets/comercial/users',
  derivarAComercial: (id) => `/api/tickets/${id}/derivarAComercial`,
  getFinanzasUsers: '/api/tickets/finanzas/users',
  derivarAFinanzas: (id) => `/api/tickets/${id}/derivarAFinanzas`,
  globalSearch: '/api/search/global',

  // clienteServicio
}

export const API_URLS_NOTA_COBRO = {
  baseUrl: process.env.VUE_APP_API_BASE_URL,

  //GET ALL DATA NOTAS DE COBRO
  getLatest: '/api/notacobros/get_latest', // LINK ../src/apps/board/store/actions.js:135
  getLatestCredito: '/api/notacobros/get_latest_credito',
  getLatest_: '/api/notacobros/get-nc-with-factura-a-cobrar',
  get_nc_a_cobrar: '/api/notacobros/get-nc-a-cobrar', // nc sin factura

  getServicios: '/api/clienteServicios/get',
  getServicios_search: '/api/clienteServicios/getServicios_simple',
  getServiciosPadres: '/api/clienteServicios/getPadres',
  getServiciosHijosByPadre: '/api/clienteServicios/getHijos/',
  verDetalleHabilitacion: '/api/ticketsTable/VerDetalleHabilitacion',
  cpanelAcciones: '/api/clienteServicios/cpanelAcciones/',
  // Resumen cPanel para soporte: SSL, SPF/DKIM/DMARC, buzones, routing de correo,
  // dominios adicionales/alias y versión PHP. Se cachea 5 min en el backend.
  cpanelResumenSoporte: (id) => `/api/clienteServicios/${id}/cpanel-resumen`,
  // Buzones de correo cPanel: listado con cuota/uso, reset de contraseña y envío
  // de credenciales por link onetime. Se cachea 5 min en el backend (?refresh=1 invalida).
  cpanelBuzones: (id) => `/api/clienteServicios/${id}/cpanel-buzones`,
  cpanelBuzonesResetPassword: (id) => `/api/clienteServicios/${id}/cpanel-buzones/reset-password`,
  cpanelBuzonesEnviarCredenciales: (id) => `/api/clienteServicios/${id}/cpanel-buzones/enviar-credenciales`,
  resetPassword: '/api/ticketsTable/VerDetalleHabilitacion/resetPassword',
  // Datos del servicio + campos no secretos para el modal de credenciales.
  datosCredenciales: '/api/ticketsTable/VerDetalleHabilitacion/datosCredenciales',
  // Regenera la clave cPanel sin guardarla en BBDD (devuelve usuario/contraseña).
  regenerarCpanel: '/api/ticketsTable/VerDetalleHabilitacion/regenerarCpanel',
  // Envía credenciales de cualquier servicio mediante link de un solo uso (onetime).
  enviarCredenciales: '/api/ticketsTable/VerDetalleHabilitacion/enviarCredenciales',
  suspenderService: '/api/habilitacion/suspenderService',
  // Suspensión en 1 paso (issue #787): datos de la vista y ejecución
  suspensionData: (id) => `/api/habilitacion/${id}/suspension-data`,
  suspenderHabilitacion: (id) => `/api/habilitacion/${id}/suspender`,
  // Habilitación temporal de servicios suspendidos (a la espera de validación de pago)
  habilitacionTemporalData: (id) => `/api/habilitacion/${id}/habilitacion-temporal-data`,
  habilitarTemporal: (id) => `/api/habilitacion/${id}/habilitar-temporal`,
  // Cambio manual de estado Pendiente -> Habilitado (issue #996), sin aprovisionamiento.
  habilitarManual: (id) => `/api/habilitacion/${id}/habilitar-manual`,
  // Adelantar pago de un servicio (issue #964): preview, ejecutar y anular.
  // data/adelantar: id = cliente_servicio_id. anular: id = nota_cobro_id.
  adelantoPagoData: (id) => `/api/habilitacion/${id}/adelanto-pago-data`,
  adelantarPago: (id) => `/api/habilitacion/${id}/adelantar-pago`,
  anularAdelanto: (id) => `/api/habilitacion/adelanto/${id}/anular`,
  editarFicha: (id) => `/api/clienteServicios/${id}/ficha`,
  servidoresDisponibles: (id) => `/api/clienteServicios/${id}/servidores-disponibles`,
  precioAdicional: (id) => `/api/clienteServicios/${id}/adicionales/precio`,
  agregarAdicionales: (id) => `/api/clienteServicios/${id}/adicionales`,

  get_notacobro_clienteservicios: '/api/notacobros/get_nc_clientesServicios',
  deleteServicio: '/api/clienteServicios/delete',

  getDefaultMessage: '/api/notacobros/getDefaultMensaje',
  getDefaultMessageNcCobro: '/api/notacobros/get-default-mensaje-nc-cobro',

  saveDefaultMessage: '/api/notacobros/saveDefaultMessage',
  saveDefaultMessageToNc: '/api/notacobros/save-default-message-nc-cobro',

  sendFacturacionMessage: '/api/notacobros/sendFacturacionMessage',
  sendCobroMessage: '/api/notacobros/sendCobroMessage',


  updateStatusNotaCobro: '/api/notacobros/updateStatusNotaCobro', //

  updateService: '/api/notacobros/updateService',
  deleteBorrador: '/api/notacobros/deleteBorrador',
  getFoliosCount: '/api/sistema/getFoliosCount',
  anular_notas: '/api/notacobros/anular-notas',
  markAsUncollectible: '/api/notacobros/mark-as-uncollectible',
  get_nc_agrupadas_by_clients: '/api/notacobros/get-nc-cobrar-agrupadas',
  get_nc_agrupadas_by_client_servicio: '/api/notacobros/get-nc-cobrar-agrupadas-clienteServicio',

  kpi_notasFacturar: '/api/notacobros/kpi',
  kpi_credito:       '/api/notacobros/kpi-credito',
  kpi_cobros:        '/api/notacobros/kpi-cobros',
  kpi_cobro_notas:   '/api/notacobros/kpi-cobro-notas',


}

// BANDEJA DE PENDIENTES
export const API_URLS_BANDEJA = {
  baseUrl: process.env.VUE_APP_API_BASE_URL,

  // GET listado paginado (params: tipo, estado, search, per_page, page)
  list: '/api/bandeja',
  // GET busca clientes asociados a un número de teléfono (param: numero)
  buscarClienteTelefono: '/api/bandeja/buscar-cliente-telefono',
  // POST acciones sobre un pendiente
  ejecutar: (id) => `/api/bandeja/${id}/ejecutar`,
  resolver: (id) => `/api/bandeja/${id}/resolver`,
  descartar: (id) => `/api/bandeja/${id}/descartar`,
}

export const API_URLS_FACTURACION = {
  baseUrl: process.env.VUE_APP_API_FACTURACION_BASE_URL,
  generarToken: '/oauth/token',

  createDte: '/api/v2/DteEmitidos/create',
  editDte: '/api/v2/DteEmitidos/edit',
  createDteNT: '/api/v2/DteEmitidos/createNT',
  createPDF: '/api/v2/DteEmitidos/createPDF',

  getNotaCredito: '/api/DteReferencias/getNotaCredito',
  enviarDteNT: '/api/DteEmitidos/enviar/',
  generarNotaCredito: '/api/DteReferencias/CreateNotaCredito',
  getXML: '/api/DteEmitidos/getXML',
  getEmitidos: '/api/DteEmitidos/getEmitidos',
  deleteDte: '/api/DteEmitidos/delete',
  emitirMultiple: '/api/DteEmitidos/emitirMultiple',
  enviarDte: '/api/DteEmitidos/enviarDte/',
  enviarTodasDte: '/api/DteEmitidos/enviarTodasDte/',
  estadoEnvioDte: '/api/DteEmitidos/estadoEnvio/',
  getDataDte: '/api/DteEmitidos/getDte/',
  updateCodAnalisisDte: '/api/DteEmitidos/updateCodAnalisisDte/',
  updateFormaPagoDte: '/api/DteEmitidos/updateFormaPagoDte/',

  getCuentasIempresario: '/api/iecuentas/getAll',
  getAllCodAnalisis: '/api/iecodanalisis/getAll',
  getCodAnalisis: '/api/iecodanalisis/get/',

  getFolios: '/api/folios/get',
  getPdfDte: '/api/DteEmitidos/getPDF'
}

/** BFF portal (`VUE_APP_API_BASE_URL`): facturación manual DTE — no mezclar con `API_URLS_FACTURACION` (motor OAuth). */
export const API_URLS_FACTURACION_DTE_BFF = {
  baseUrl: process.env.VUE_APP_API_BASE_URL,

  ping: '/api/facturacion/dte/ping',
  borradores: '/api/facturacion/dte/borradores',
  borradoresEditar: '/api/facturacion/dte/borradores/editar',
  borradoresEliminar: '/api/facturacion/dte/borradores/eliminar',
  enviar: (idDte) => `/api/facturacion/dte/enviar/${idDte}`,
  reintentar: (idDte) => `/api/facturacion/dte/reintentar/${idDte}`,
  marcarAceptada: (idDte) => `/api/facturacion/dte/marcar-aceptada/${idDte}`,
  codAnalisis: '/api/facturacion/dte/cod-analisis',
  folios: '/api/facturacion/dte/folios',
  // Administración de CAF (folios): listar todos y cargar uno nuevo. El XML no se loguea.
  foliosListar: '/api/facturacion/dte/folios/listar',
  foliosCargar: '/api/facturacion/dte/folios/cargar',
  iecuentas: '/api/facturacion/dte/iecuentas',
  iecodanalisis: '/api/facturacion/dte/iecodanalisis',
  iecodanalisisByCuenta: (cuentaId) => `/api/facturacion/dte/iecodanalisis/${cuentaId}`,
  borradorPdf: '/api/facturacion/dte/borrador-pdf',

  // Passthrough del motor vía BFF (el front NO habla directo con el motor). Devuelven el
  // MISMO JSON/binario que hoy entrega el motor, así el render del front no cambia.
  get: (idDte) => `/api/facturacion/dte/get/${idDte}`,   // consulta DTE (getDte)
  create: '/api/facturacion/dte/create',                 // crear DTE crudo (re-emisión)
  emitirMultiple: '/api/facturacion/dte/emitir-multiple',// regenerar / emitir múltiple
  emitidos: '/api/facturacion/dte/emitidos',             // listado paginado (getEmitidos)
  crearPdf: '/api/facturacion/dte/create-pdf',           // PDF preview (createPDF)
  formaPago: '/api/facturacion/dte/forma-pago',          // updateFormaPagoDte
  ncReferencias: '/api/facturacion/dte/nc/referencias',  // getNotaCredito (referencias NC)

  // Nota de Crédito vía BFF (el front NO habla directo con el motor).
  ncGetXml: '/api/facturacion/dte/nc/getxml',
  ncCrear: '/api/facturacion/dte/nc/crear',
  ncPreview: '/api/facturacion/dte/nc/preview',
  // Emisión de la NC por la ruta SÍNCRONA del motor (veredicto real, no async como
  // el enviar de factura). Ver FacturacionRevisionNota.enviarDtes.
  ncEnviar: (idDte) => `/api/facturacion/dte/nc/enviar/${idDte}`,
  ncPdf: (idDte) => `/api/facturacion/dte/nc/pdf/${idDte}`,
}

export const API_URLS_NOTA_COBRO_DTE = {
  baseUrl: process.env.VUE_APP_API_BASE_URL,

  create: '/api/notacobros_dte/create',
  crateFacturaVenta: '/api/notacobros_dte/crateFacturaVenta',
  crateFacturaNotaCobro: '/api/notacobros_dte/crateFacturaNotaCobro',

  updateStatusNotaCobroFacturacion: '/api/notacobros_dte/updateStatusNotaCobroFacturacion', //

  // Vincula una nota de crédito a la nota de cobro de su factura de referencia.
  linkNotaCredito: '/api/notacobros_dte/linkNotaCredito',
  // Vincula una factura re-emitida (tras anular) a la nota de cobro original.
  linkFacturaReemitida: '/api/notacobros_dte/linkFacturaReemitida',
}

export const API_URLS_SOFONO = {
  baseUrl: process.env.VUE_APP_API_BASE_URL,

  getAll: '/api/sofono/getAll',
  indicadores: '/api/sofono/indicadores',
  getCategorias: '/api/sofono/getCategorias',
  getBaseData: '/api/sofono/getBaseData',

  getClientData: '/api/sofono/getClientData',
  createSofono: '/api/sofono/createSofono',



}

export const API_URLS_PRE_SOFONO = {
  baseUrl: process.env.VUE_APP_API_BASE_URL,

  getAll: '/api/pre-sofono/getAll',
  getPlanes: '/api/pre-sofono/getPlanes',
  buscarCliente: '/api/pre-sofono/buscarCliente',
  // completar:  `/api/pre-sofono/${id}/completar`
  // desestimar: `/api/pre-sofono/${id}/desestimar`
  completar: '/api/pre-sofono',
  desestimar: '/api/pre-sofono',
}

export const API_URLS_COTIZACIONES = {
  baseUrl: process.env.VUE_APP_API_BASE_URL,

  getFiles: '/api/cotizacion/getfilePath',
  getAll: '/api/cotizacion/getAll',
  getService: '/api/cotizacion/getService',
  getBasePage: '/api/cotizacion/getBasePage',
  getItem: '/api/cotizacion/getItem',
  getBaseData: '/api/cotizacion/getBaseData',
  generarPdfs: '/api/cotizacion/generarPdfs',

  getDefaultMessage: '/api/cotizacion/getDefaultMensaje',
  saveDefaultMessage: '/api/cotizacion/saveDefaultMessage',
  generarCotizaciones: '/api/cotizacion/create',
  updateCotizaciones: '/api/cotizacion/update',
  validateFiles: '/api/cotizacion/validateFiles',
  validateFilesPropuestaTemp: '/api/cotizacion/validateFilesPropuestaTemp',
  validateFilesPropuesta: '/api/cotizacion/validateFilesPropuesta',

  sendPropuestas: '/api/cotizacion/sendPropuestas',

  editarCotizaciones: '/api/cotizacion/edit',
  editarEnviarCotizaciones: '/api/cotizacion/editAndSendCotizaciones',

  copiarCotizaciones: '/api/cotizacion/copyCotizaciones',
  eliminarProyecto: '/api/cotizacion/deleteProyecto',
  clearData: '/api/cotizacion/deleteData',
  aceptar: '/api/cotizacion/aceptar',

  getDataPropuesta: '/api/cotizacion/getDataPropuesta',

  validateUserData: '/api/cotizacion/validateUserData',


}


export const API_URLS_CLIENTE = {
  baseUrl: process.env.VUE_APP_API_BASE_URL,

  getAll: '/api/clientes/getAll',
  validateTokenImpersonation: '/api/impersonate-client',

  getBaseData: '/api/clientes/getBaseData',
  createCliente: '/api/clientes/createCliente',
  sugerirUsername: '/api/clientes/sugerir-username',
  usernameDisponible: '/api/clientes/username-disponible',
  updateCliente: '/api/clientes/updateCliente',
  suspensionsClients: '/api/clientes/getSuspension',
  suspensionsClientsUpdate: '/api/clientes/suspensionsClientsUpdate',
  updateUsuarioEncargadoACliente: '/api/clientes/update-usuario-encargado',

  // Cartola y saldo a favor
  cartola: (clienteId) => `/api/clientes/cartola/${clienteId}`,
}

export const API_URLS_USUARIO = {
  baseUrl: process.env.VUE_APP_API_BASE_URL,

  getAll: '/api/usuarios/getAll',

  // Opciones de departamento (catálogo activo) para el selector del mantenedor.
  departamentosDisponibles: '/api/usuarios/departamentos-disponibles',

  createUser: '/api/usuarios/createUser',
  updateUser: '/api/usuarios/updateUser',
  deleteUser: '/api/usuarios/deleteUser',
  deleteUserToken: '/api/usuarios/deleteUserToken',
  delete2faUser: '/api/usuarios/deleteUser2fa',
}

export const API_URLS_ROLES = {
  baseUrl: process.env.VUE_APP_API_BASE_URL,

  getAll: '/api/roles/getAll',
  getAllPermissions: '/api/roles/getAllPermissions',
  getDataRole: '/api/roles/getDataRole',

  createRole: '/api/roles/createRole',
  updateRole: '/api/roles/updateRole',
  deleteRole: '/api/roles/deleteRole',

}

export const API_URLS_COUPONS = {
  baseUrl: process.env.VUE_APP_API_BASE_URL,
  getAll: '/api/coupons/getAll',
  getAllCategories: '/api/coupons/getAllCategories',
  create: '/api/coupons/createCoupon',
  update: '/api/coupons/update',
  delete: '/api/coupons/delete',

  getAllHistory: '/api/coupons/getAllHistory',
  deleteHistory: '/api/coupons/deleteHistory',


  // getAllPermissions: '/api/coupons/getAllPermissions',
  // getDataRole: '/api/coupon/getDataRole',
}


export const API_URLS_CLIENTESERVICIO = {
  baseUrl: process.env.VUE_APP_API_BASE_URL,
  getListadoForFiltersHabilitation: '/api/clienteServicios/getListadoForFiltersHabilitation',
  getPendientesCount: '/api/clienteServicios/pendientesCount',

  getServiciosbycategoriasLite: '/api/servicios/getServiciosbycategoriasLite',
  getAllCategories: '/api/categorias/getAllCategories',
  // sendResumeTo: '/api/notacobros/contratar', //POST
  sendCartTo: '/api/portal/habilitaciones/contratar', //POST

  checkDomain: '/api/dominios/check',
  getMiniListHabilitation: '/get-mini-list-habilitation',

  // Migración de dominio (transfer-in vía EPP) — issue #1093.
  estadoTransferenciaDominio: (clienteServicioId) => `/api/habilitacion/dominio/${clienteServicioId}/estado-transferencia`, // GET
  reintentarTransferenciaDominio: (clienteServicioId) => `/api/habilitacion/dominio/${clienteServicioId}/reintentar-transferencia`, // POST
  // Requisitos de datos del cliente para registrar/migrar un dominio en OpenProvider.
  requisitosClienteDominio: (clienteId) => `/api/habilitacion/dominio/requisitos-cliente/${clienteId}`, // GET
}


/** Nameservers (NS) de un dominio contratado (OpenProvider) — Issue #1094/#1297. */
export const API_URLS_DOMINIO_NS = {
  baseUrl: process.env.VUE_APP_API_BASE_URL,
  // {id} = cliente_servicio_id
  nameservers: (id) => `/api/servicios/${id}/dominio/nameservers`,
}


export const API_URLS_FACTURACION_COMPRA = {
  baseUrl: process.env.VUE_APP_API_DTE_URL,

  base_proveedor: '/api/proveedores', // create, obtener y delete
  editar_proveedor: '/api/editarproveedor', // POST editar
  get_proveedores_activos: '/api/proveedores/activos', //POST
  get_proveedores: '/api/proveedorfiltro', //POST
  cambiar_estado_proveedor: '/api/estadoproveedor', //desactivar/reactivar multiple

  create_reglas_proveedor: '/api/proveedores/reglas',
  get_reglas_proveedor: '/api/proveedores/reglasver',
  get_reglas: '/api/proveedores/reglafiltro',
  editar_regla: '/api/proveedores/reglaupdate',
  cambiar_estado_regla: '/api/proveedores/regla-estado-activo',
  get_cuentas: 'api/vericuentas',
  import_dte: '/api/sii/importardte',
  getDtes: '/api/allDataresumen',

  generateTransfer: '/api/transferencia/crear-transferencia',
  download_transferencia: '/api/transferencia/descargar',
  marcar_como_pagada: '/api/pagos-directos/pagar-directo',
  descargar_file_pago_directo: '/api/pagos-directos/descargar',
  getIndicadores: '/api/indicadores/resumen',
  asignar_manual: '/api/proveedores/asignar-manual',
  getRegistrosMail: '/api/dte/registromail/listar', //obtener registros de reglas para validar 
  // getAllClienteServicio: '/api/portal/clientes/clienteservicio'
}

export const API_URLS_MANAGES_NOTAS_COBRO = {
  baseUrl: process.env.VUE_APP_API_BASE_URL,

  base_manage: '/api/notacobros-manage',
  base_manage_no_generated: '/api/notacobros-manage/no-generadas',

  // getAllClienteServicio: '/api/portal/clientes/clienteservicio'
}

// Transacciones Webpay (pagos Transbank)
export const API_URLS_WEBPAY = {
  baseUrl: process.env.VUE_APP_API_BASE_URL,

  // Listado paginado de transacciones Webpay (server-side: page, per_page,
  // search, fecha_desde, fecha_hasta)
  transactions: '/api/transacciones-webpay/transactions',
  kpis: '/api/transacciones-webpay/kpis',
}

/**
 * Retorna la URL del endpoint para desnotificar el pago de una nota de cobro.
 * Requiere permiso cobros.update en el backend.
 *
 * @param {number|string} id - ID de la nota de cobro.
 * @returns {string} URL completa lista para usar con axios.
 */
export const getDesnotificarPagoUrl = (id) =>
  `${process.env.VUE_APP_API_BASE_URL}/api/notacobros/${id}/desnotificar-pago`;

export const API_URLS_COBROS_FACTURAS = {
  baseUrl: process.env.VUE_APP_API_BASE_URL,
  base_manage: '/api/cobros-facturas-manage',
  // cartera por cliente de las NC que ya tienen factura emitida
  agrupado_clientes: '/api/cobros-facturas-manage/agrupado-clientes',
  // pendientes de backend: no existen aún como endpoints
  marcar_cobrada: '/api/cobros-facturas/marcar-cobrada',
  anular: '/api/cobros-facturas/anular',
}

// Constantes para Transferencias
export const API_URLS_TRANSFERENCIA = {
  baseUrl: process.env.VUE_APP_API_DTE_URL,

  listar_transferencias: '/api/transferencia/listar-transferencia',
  listar_dte_transferencia: '/api/transferencia/listarDte-tranferencia',
  generar_documento: '/api/transferencia/generar-documento',
  validar_banco: '/api/transferencia/validar-banco',
  desactivar_transferencia: '/api/transferencia/desactivar-transferencia',
  get_bancos: '/api/bancos/listar',
  get_medioPago: '/api/tipo-pago/listar',
  listar_dte_transferencia: '/api/transferencia/listarDte-tranferencia',
  validar_banco: '/api/transferencia/validar-banco',
  descargar_archivos: '/api/descargas/archivo'

};

export const API_URLS_CREDITO = {
  baseUrl: process.env.VUE_APP_API_DTE_URL + '/api/credito',
  creditos_facturas: "/creditos-facturas",
  vincular_credito_factura: "/vincular-credito-factura",
  eliminar_vinculos: "/eliminar-vinculos",
  listar_creditosvinculados: "/listar-creditosvinculados"
};

// Constantes para Transferencias de Clientes
export const API_URLS_TRANSFERENCIA_CLIENTE = {
  baseUrl: process.env.VUE_APP_API_BASE_URL + '/api/transferencias-electronicas',

  asociar: '/asociar',
  estadisticas: '/get-estadisticas',
  create: '/create',
};

// Constantes para Pagos Manuales
export const API_URLS_PAGOS_MANUALES = {
  baseUrl: process.env.VUE_APP_API_BASE_URL + '/api/pagos-manuales',
};

// Mantenedor Templates de Correo
export const API_URLS_TEMPLATES = {
  baseUrl: process.env.VUE_APP_API_BASE_URL,
  list: '/api/templates',
  detail: '/api/templates',   // + /{templateKey}
  preview: '/preview',        // POST detail + /{templateKey}/preview
  restore: '/restore',        // POST detail + /{templateKey}/restore
  testSend: '/test-send',     // POST detail + /{templateKey}/test-send
};

// Constantes para Planes de Servicios (alineado con backend /planes-servicios)
export const API_URLS_PLANES = {
  baseUrl: process.env.VUE_APP_API_BASE_URL + '/api/planes-servicios',
  formData: process.env.VUE_APP_API_BASE_URL + '/api/planes-servicios/form-data',
  camposByCategoria: (categoriaId) => `/campos-by-categoria/${categoriaId}`,
  categorias: process.env.VUE_APP_API_BASE_URL + '/api/categorias/getAllCategories',
  periodicidades: process.env.VUE_APP_API_BASE_URL + '/api/periodicidades/getAll',
  monedas: process.env.VUE_APP_API_BASE_URL + '/api/monedas/getAll',
};

// Proveedores internacionales (Cloudflare, Vultr, Manage2, OpenProvider, Enhance, etc.)
// Backend bajo /api/proveedores-internacionales. Las rutas relativas se arman en
// src/services/proveedoresInternacionales.js
export const API_URLS_PROVEEDORES_INTERNACIONALES = {
  baseUrl: process.env.VUE_APP_API_BASE_URL + '/api/proveedores-internacionales',
};

// Definir constantes de API (ajustar según tu estructura)
export const API_URLS_FACTURAS_EMITIDAS = {
  baseUrl: process.env.VUE_APP_API_BASE_URL + '/api',
  base_manage: '/facturas-emitidas',
  detalle: '/facturas-emitidas',
  reenviar_sii: '/facturas-emitidas/reenviar-sii',
  consultar_estado_sii: '/facturas-emitidas/consultar-estado-sii',
  descargar_pdf: '/facturas-emitidas/descargar-pdf',
  descargar_xml: '/facturas-emitidas/descargar-xml',
  descargar_masivo: '/facturas-emitidas/descargar-masivo',
  exportar_excel: '/facturas-emitidas/exportar-excel',
  kpi: '/facturas-emitidas/kpi',
  export_iempresario_listar: '/facturas-emitidas/export-iempresario/listar',
  export_iempresario_excel: '/facturas-emitidas/export-iempresario/excel',
};

/** Acceso IP internacional temporal (MW / firewall) — rutas bajo grupo `auth` en Laravel */
export const API_URLS_ACCESO_TEMPORAL = {
  baseUrl: process.env.VUE_APP_API_BASE_URL,
  listarPermisoTemporal: '/api/listarpermisotemporal',
  agregarAccesoTemporalInterno: '/api/agregarAccesoTemporal-interno',
};

/** Redes: gestión de políticas de firewall (Fortinet/middleware) */
export const API_URLS_REDES_MW = {
  baseUrl: process.env.VUE_APP_API_BASE_URL,
  reglaVertabla:  '/api/mw/reglas/vertabla',
  reglaCrear:     '/api/mw/reglas/crear',
  reglaEliminar:  '/api/mw/reglas/eliminar',
  services:       '/api/mw/services',
  serviceGroups:  '/api/mw/service-groups',
  addressGroups:  '/api/mw/address-groups',          // POST { vdom, search? }
  addressGroupIps:'/api/mw/address-groups/ips',       // POST { vdom? }  (omitir vdom = todos)
  agregarIpGrupo: '/api/mw/reglas/agregar-ip-grupo',  // POST { ip, vdom, grupo, agente_soporte }
  vdomList:       '/api/vdom',
  vdomCrear:      '/api/vdom/crear',
  vdomEstado:     '/api/vdom/estado', // + /{id}
};

/** Mantenedor de Categorías y Super Categorías */
export const API_URLS_CATEGORIAS = {
  baseUrl: process.env.VUE_APP_API_BASE_URL,
  getAll:        '/api/categorias',
  formData:      '/api/categorias/form-data',
  create:        '/api/categorias',
  update:        '/api/categorias',
  delete:        '/api/categorias',
  getAllSuper:   '/api/super-categorias',
  formDataSuper: '/api/super-categorias/form-data',
  createSuper:   '/api/super-categorias',
  updateSuper:   '/api/super-categorias',
  deleteSuper:   '/api/super-categorias',
};

/** SMTP temporal y poolname (portal API) */
export const API_URLS_SMTP = {
  baseUrl: process.env.VUE_APP_API_BASE_URL,
  temporalVer: '/api/smtp/temporal/ver',
  temporalGestionar: '/api/smtp/temporal/gestionar',
  temporalDesactivarManual: '/api/smtp/temporal/desactivar-manual',
  poolnameVer: '/api/smtp/poolname/ver',
  poolnameAgregar: '/api/smtp/poolname/agregar',
  poolnameEliminar: '/api/smtp/poolname/eliminar',
};

/** API Tokens — gestión de tokens de acceso a endpoints de portalclientes-api */
export const API_URLS_API_TOKENS = {
  baseUrl: process.env.VUE_APP_API_BASE_URL,
  getAll: '/api/api-tokens',
  create: '/api/api-tokens',
  update: (id) => `/api/api-tokens/${id}`,
  remove: (id) => `/api/api-tokens/${id}`,
  scopes: '/api/api-tokens/scopes',
};

/** Servidores — mantenedor de catálogo de servidores de hosting */
export const API_URLS_SERVIDORES = {
  baseUrl:        process.env.VUE_APP_API_BASE_URL,
  getAll:         '/api/servidores',
  getOne:         '/api/servidores/',
  create:         '/api/servidores',
  update:         '/api/servidores/',
  updateEstado:   '/api/servidores/',
  underAttack:    '/api/servidores/', // se usa como underAttack + id + '/under-attack'
  estadisticas:   '/api/servidores/estadisticas',
};

/** Mantenedor de Campos de Servicio */
export const API_URLS_CAMPOS = {
  baseUrl:      process.env.VUE_APP_API_BASE_URL,
  getAll:       '/api/campos-servicio',
  create:       '/api/campos-servicio',
  update:       (id) => `/api/campos-servicio/${id}`,
  remove:       (id) => `/api/campos-servicio/${id}`,
  detail:       (id) => `/api/campos-servicio/${id}`,
  toggleActivo:          (id) => `/api/campos-servicio/${id}/activo`,
  categoriasDisponibles: '/api/campos-servicio/categorias-disponibles',
};

/** Mantenedor de Contratos de Servicio */
export const API_URLS_CONTRATOS = {
  baseUrl:       process.env.VUE_APP_API_BASE_URL,
  getAll:        '/api/contratos',
  detail:        (id) => `/api/contratos/${id}`,
  create:        '/api/contratos',
  update:        (id) => `/api/contratos/${id}`,
  download:      (id) => `/api/contratos/${id}/archivo`,
  downloadInline:(id) => `/api/contratos/${id}/archivo?inline=1`,
  deleteArchivo: (id) => `/api/contratos/${id}/archivo`,
  remove:        (id) => `/api/contratos/${id}`,
};

export const API_URLS_PERIODICIDADES = {
  baseUrl: process.env.VUE_APP_API_BASE_URL,
  list: '/api/periodicidades',
  detail: (id) => `/api/periodicidades/${id}`,
  create: '/api/periodicidades',
  update: (id) => `/api/periodicidades/${id}`,
  toggleEstado: (id) => `/api/periodicidades/${id}/estado`,
  usos: (id) => `/api/periodicidades/${id}/usos`,
};

/**
 * Escalera de precios (USD) de las licencias cPanel/Manage2, por número de cuentas.
 * Sólo lectura y edición: los cinco tramos son fijos y no se crean ni se borran.
 */
export const API_URLS_TARIFAS_MANAGE2 = {
  baseUrl: process.env.VUE_APP_API_BASE_URL,
  list: '/api/tarifas-manage2',
  historial: '/api/tarifas-manage2/historial',
  update: (id) => `/api/tarifas-manage2/${id}`,
};

/**
 * Filtros del email-to-ticket (lista negra de correos entrantes).
 * Gestiona las tres listas de config `mail_tickets.php`:
 *  - blocked_emails: correos exactos bloqueados.
 *  - blocked_email_keywords: palabras clave que, si aparecen en el remitente, bloquean.
 *  - blocked_subject_keywords: palabras clave que, si aparecen en el asunto, marcan como spam.
 * `agregar`/`eliminar` reciben { tipo, valor }.
 */
export const API_URLS_MAIL_TICKET_FILTRO = {
  baseUrl: process.env.VUE_APP_API_BASE_URL,
  listar:   '/api/mailticketmostrarfiltro', // GET
  agregar:  '/api/mailticketagregar',       // POST { tipo, valor }
  eliminar: '/api/mailticketeliminar',      // POST { tipo, valor }
};

/**
 * Bitácora de correos enviados a un cliente (panel admin).
 * GET base/{clienteId} — paginado Laravel. Params: estado, desde, hasta, page, per_page.
 * Estado = nivel relay SMTP (no confirma entrega en bandeja).
 */
export const API_URLS_EMAIL_LOG = {
  baseUrl: process.env.VUE_APP_API_BASE_URL,
  porCliente: (clienteId) => `/api/clientes/${clienteId}/email-log`,
  // Bitácora global (vista admin de todos los correos del sistema).
  todos: '/api/email-log',
};

/**
 * NS / MX de dominios — gestión manual de la zona DNS (NS1/NS2) y del dominio en
 * MailCleaner, para corregir a mano lo que el flujo automático dejó desalineado.
 * Las acciones son asíncronas: devuelven `operacion_id` y se sigue con `operacion(id)`.
 */
export const API_URLS_NS_MX = {
  baseUrl:     process.env.VUE_APP_API_BASE_URL,
  servidores:  '/api/ns-mx/servidores',                    // GET
  revisar:     '/api/ns-mx/revisar',                       // POST { dominio }
  crear:       '/api/ns-mx/crear',                         // POST { dominio, servidor_id, motivo }
  eliminar:    '/api/ns-mx/eliminar',                      // POST { dominio, servidor_id?, motivo }
  recrear:     '/api/ns-mx/recrear',                       // POST { dominio, servidor_id, motivo }
  operaciones: '/api/ns-mx/operaciones',                   // GET (paginado)
  operacion:   (id) => `/api/ns-mx/operaciones/${id}`,     // GET
};

/** Clientes Administrados — contratos vigentes en categoría 21 (Administración/Monitoreo) */
export const API_CLIENTES_ADMINISTRADOS = {
  baseUrl: process.env.VUE_APP_API_BASE_URL,
  list:       '/api/clientes-administrados',
  detail:     (id) => `/api/clientes-administrados/${id}`,
  onboarding: (id) => `/api/clientes-administrados/${id}/onboarding`,
};

/**
 * Visitas Datacenter — solicitudes de ingreso al datacenter (mantención /
 * clientes), con aprobación de supervisor y marcaje real de entrada/salida
 * por persona. El 409 con `codigo: COLOCATION_SUSPENDIDO` en `create` pide
 * confirmación excepcional (reenviar con `confirmar_suspendido: true`).
 */
export const API_URLS_VISITAS_DATACENTER = {
  baseUrl:        process.env.VUE_APP_API_BASE_URL,
  list:           '/api/visitas-datacenter',                                        // GET (paginado + filtros)
  formData:       '/api/visitas-datacenter/form-data',                              // GET datacenters activos + catálogos
  enDatacenter:   '/api/visitas-datacenter/en-datacenter',                          // GET personas actualmente dentro
  show:           (id) => `/api/visitas-datacenter/${id}`,                          // GET
  create:         '/api/visitas-datacenter',                                        // POST
  precargaTicket: (ticketId) => `/api/visitas-datacenter/precarga-ticket/${ticketId}`, // GET cliente + estado CoLocation
  buscarClientes: '/api/visitas-datacenter/buscar-clientes',                        // GET ?search= (solo clientes CoLocation)
  aprobar:        (id) => `/api/visitas-datacenter/${id}/aprobar`,                  // POST
  rechazar:       (id) => `/api/visitas-datacenter/${id}/rechazar`,                 // POST { motivo_rechazo }
  anular:         (id) => `/api/visitas-datacenter/${id}/anular`,                   // POST
  finalizar:      (id) => `/api/visitas-datacenter/${id}/finalizar`,                // POST
  // Nómina de personas: la API sólo lo permite si la solicitud está pendiente.
  sugerencias:    '/api/visitas-datacenter/sugerencias',                                            // GET ?search= (cliente, empresa, persona)
  // Ticket de seguimiento: se asocia mientras la solicitud está pendiente.
  buscarTicket:   (ticketId) => `/api/visitas-datacenter/tickets/${ticketId}`,                      // GET
  asociarTicket:  (id) => `/api/visitas-datacenter/${id}/asociar-ticket`,                           // POST { ticket_id | null }
  agregarPersona: (id) => `/api/visitas-datacenter/${id}/personas`,                                 // POST { nombre, apellido, rut }
  quitarPersona:  (id, personaId) => `/api/visitas-datacenter/${id}/personas/${personaId}`,         // DELETE
  marcarIngreso:  (id, personaId) => `/api/visitas-datacenter/${id}/personas/${personaId}/ingreso`, // POST
  marcarSalida:   (id, personaId) => `/api/visitas-datacenter/${id}/personas/${personaId}/salida`,  // POST
};

/** Datacenters — mantenedor del catálogo de datacenters físicos */
export const API_URLS_DATACENTERS = {
  baseUrl:      process.env.VUE_APP_API_BASE_URL,
  list:         '/api/datacenters',                          // GET (paginado + filtros)
  create:       '/api/datacenters',                          // POST { nombre, ubicacion?, activo? }
  update:       (id) => `/api/datacenters/${id}`,            // PUT
  toggleEstado: (id) => `/api/datacenters/${id}/estado`,     // PATCH
};

/** Departamentos — mantenedor del catálogo de departamentos internos */
export const API_URLS_DEPARTAMENTOS = {
  baseUrl:      process.env.VUE_APP_API_BASE_URL,
  list:         '/api/departamentos',                        // GET (paginado + filtros)
  encargados:   '/api/departamentos/encargados',             // GET (usuarios activos para el selector)
  create:       '/api/departamentos',                        // POST { nombre, encargado_id, activo? }
  update:       (id) => `/api/departamentos/${id}`,          // PUT
  toggleEstado: (id) => `/api/departamentos/${id}/estado`,   // PATCH
};

// [#1039] Devoluciones de saldo a favor (backend portal, Issue #1237).
export const API_URLS_DEVOLUCIONES = {
    baseUrl: process.env.VUE_APP_API_BASE_URL,
    base: '/api/devoluciones', // GET listar, POST crear, PUT {id} editar, DELETE {id} anular
    clientesConSaldo: '/api/devoluciones/clientes-con-saldo',
    bancos: '/api/devoluciones/bancos',
    generarArchivo: '/api/devoluciones/generar-archivo',
    regenerarArchivo: '/api/devoluciones/regenerar-archivo',
    marcarPagado: '/api/devoluciones/marcar-pagado',
    marcarRechazado: '/api/devoluciones/marcar-rechazado',
}

// Dashboard de Automatizaciones (estado de las tareas programadas / crons del
// portal). Solo lectura. Permiso automatizaciones.view.
export const API_URLS_AUTOMATIZACIONES = {
    baseUrl: process.env.VUE_APP_API_BASE_URL,
    resumen: '/api/automatizaciones/resumen',
    tareas: '/api/automatizaciones/tareas',
    ejecuciones: '/api/automatizaciones/ejecuciones',
}

// [#1237] Ajuste manual de saldo a favor (ingreso/egreso por corrección). Permiso saldo.ajustar.
export const API_URLS_SALDO = {
    baseUrl: process.env.VUE_APP_API_BASE_URL,
    buscarClientes: '/api/clientes/saldo/buscar',
    ajustar: '/api/clientes/saldo/ajuste',
}

/**
 * Textos de Tickets — mantenedor de la redacción de los mensajes que el
 * sistema publica solo en los tickets automáticos (ej: visitas al datacenter).
 * El catálogo y los valores por defecto viven en la API; aquí sólo se editan.
 */
export const API_URLS_TEXTOS_TICKET = {
  baseUrl:   process.env.VUE_APP_API_BASE_URL,
  list:      '/api/textos-ticket',                                   // GET
  show:      (clave) => `/api/textos-ticket/${clave}`,               // GET
  update:    (clave) => `/api/textos-ticket/${clave}`,               // PUT { titulo?, cuerpo? }
  restaurar: (clave) => `/api/textos-ticket/${clave}/restaurar`,     // POST
  preview:   (clave) => `/api/textos-ticket/${clave}/preview`,       // POST { titulo?, cuerpo? }
};

/**
 * Aire Acondicionado — ronda diaria de revisión de los equipos del datacenter
 * (temperaturas, checklist, comentarios y fotos), estado del parque, alertas de
 * falla y el mantenedor de salas, equipos, checklist y configuración.
 */
export const API_URLS_AIRE_ACONDICIONADO = {
  baseUrl:  process.env.VUE_APP_API_BASE_URL,

  // Ronda
  formData:          '/api/aire-acondicionado/form-data',                                  // GET datacenters + salas + checklist
  rondas:            '/api/aire-acondicionado/rondas',                                     // GET (paginado) · POST iniciar
  ronda:             (id) => `/api/aire-acondicionado/rondas/${id}`,                       // GET detalle
  guardarLectura:    (id, lecturaId) => `/api/aire-acondicionado/rondas/${id}/lecturas/${lecturaId}`, // PUT
  guardarSala:       (id, salaId) => `/api/aire-acondicionado/rondas/${id}/salas/${salaId}`,          // PUT
  comentarioGeneral: (id) => `/api/aire-acondicionado/rondas/${id}/comentario-general`,     // PUT
  todosConformes:    (id) => `/api/aire-acondicionado/rondas/${id}/todos-conformes`,        // POST
  finalizarRonda:    (id) => `/api/aire-acondicionado/rondas/${id}/finalizar`,              // POST
  anularRonda:       (id) => `/api/aire-acondicionado/rondas/${id}/anular`,                 // POST { motivo_anulacion }

  // Fotos (opcionales, acompañan a un comentario)
  subirArchivos:     (id) => `/api/aire-acondicionado/rondas/${id}/archivos`,               // POST multipart archivos[]
  archivo:           (archivoId) => `/api/aire-acondicionado/archivos/${archivoId}`,        // GET descarga · DELETE

  // Estado del parque y alertas de falla
  estadoEquipos:     '/api/aire-acondicionado/equipos/estado',                              // GET
  alertas:           '/api/aire-acondicionado/alertas',                                     // GET (paginado)
  resolverAlerta:    (id) => `/api/aire-acondicionado/alertas/${id}/resolver`,              // POST { resolucion }

  // Mantenedor
  salas:             '/api/aire-acondicionado/salas',                                       // GET · POST
  sala:              (id) => `/api/aire-acondicionado/salas/${id}`,                         // PUT
  salaEstado:        (id) => `/api/aire-acondicionado/salas/${id}/estado`,                  // PATCH
  equipos:           '/api/aire-acondicionado/equipos',                                     // GET · POST
  equipo:            (id) => `/api/aire-acondicionado/equipos/${id}`,                       // PUT
  equipoEstado:      (id) => `/api/aire-acondicionado/equipos/${id}/estado`,                // PATCH
  config:            '/api/aire-acondicionado/config',                                      // GET · PUT
  checklistItems:    '/api/aire-acondicionado/config/checklist',                            // POST
  checklistItem:     (id) => `/api/aire-acondicionado/config/checklist/${id}`,              // PUT
  checklistEstado:   (id) => `/api/aire-acondicionado/config/checklist/${id}/estado`,       // PATCH
};
